import { ITagView } from '@/contracts/modules/libre/use-case/ITagView'
import { ILibreTree } from '@/contracts/modules/libre/use-case/ILibreTree'
import { ILibreTagGroup } from '@/contracts/modules/libre/entities/ILibreFound'
import { ILibreNode } from '@/contracts/modules/libre/entities/ILibreNode'

/**
 * Узлы с действующим тегом группируются по ближайшему предку (или себе), у которого тег свой:
 * так рядом видны ветви из разных разделов. Группы и узлы — в порядке обхода дерева.
 */
export class TagView implements ITagView {
  exec(tree: ILibreTree, tag: string): ILibreTagGroup[] {
    const groups = new Map<string, ILibreTagGroup>()
    tree.all()
      .filter((node) => tree.effectiveTags(node.getUuid()).includes(tag))
      .forEach((node) => {
        const root = this.ownerOfTag(tree, node, tag)
        let group = groups.get(root.getUuid())
        if (group === undefined) {
          group = { root: { node: root, path: tree.ancestors(root.getUuid()) }, nodes: [] }
          groups.set(root.getUuid(), group)
        }
        if (root.getUuid() !== node.getUuid()) {
          group.nodes.push({ node, path: tree.ancestors(node.getUuid()) })
        }
      })
    return [...groups.values()]
  }

  private ownerOfTag(tree: ILibreTree, node: ILibreNode, tag: string): ILibreNode {
    if (node.getTags().includes(tag)) {
      return node
    }
    const owner = [...tree.ancestors(node.getUuid())].reverse().find((ancestor) => ancestor.getTags().includes(tag))
    return owner ?? node
  }
}
